import { render, staticRenderFns } from "./HolidaysPrograms.vue?vue&type=template&id=5fbe0fe9&scoped=true&"
import script from "./HolidaysPrograms.vue?vue&type=script&lang=ts&"
export * from "./HolidaysPrograms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe0fe9",
  null
  
)

export default component.exports